/**
 * Gets the cartesian product of two arrays
 *
 * @param one - The first array
 * @param two - The second array
 * @returns The cartesian product of the two arrays
 */
export function cartesianProduct<T = unknown, K = unknown>(one: T[], two: K[]): Array<[T, K]> {
    const result: Array<[T, K]> = [];
    for (let first = 0; first < one.length; first++) {
        for (let second = 0; second < two.length; second++) {
            result.push([one[first], two[second]]);
        }
    }
    return result;
}
